import React, { useState, useEffect, useContext } from "react";
import { PaymentNachaContext } from "../contexts/PaymentNachaContext";
import { CarrierContext } from "../contexts/CarrierContext";
import ReactDOMServer from "react-dom/server";
import { dompurifyInput, dompurifyHtml } from "../utils/sanitizeInput";

const EFTForm = ({
  showEftTab,
  isEnableEft,
  allowedEftTypes,
  form,
  setForm,
  accountErrors,
  setAccountErrors,
  totalAmountDue,
  payOtherAmount,
  showTotalAmt,
  cms,
  setShowSubmitBtn,
  accountFormValidate,
  //setNachaAuthMessage,
}) => {
  const [currentDate, setCurrentDate] = useState("");
  const [updatedNachaContent, setUpdatedNachaContent] = useState("");
  const [isVisibleEFTFormDown, setIsVisibleEFTFormDown] = useState(false);
  const [isVisibleEFTBtnContinue, setIsVisibleEFTBtnContinue] = useState(false);
  const {
    getNachaContent,
    nachaContent,
    setNachaContent,
    nachaMainHeading,
    nachaTermsConditions,
    nachaESign,
    nachaCarrierName,
    nachaBillingFreq,
    nachaContentSubHeading,
  } = useContext(PaymentNachaContext);
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    }); // 'en-GB' formats as DD/MM/YYYY
    setCurrentDate(formattedDate);
    setIsVisibleEFTBtnContinue(true);
  }, []);

  /* Mask Routing number */
  const [shownRoutingNumber, setShownRoutingNumber] = useState(""); // The value shown in the input field
  const [hiddenRoutingNumber, setHiddenRoutingNumber] = useState(""); // The raw card number

  const showWithoutXsRoutingNumber = () => {
    // Set the input field value to the hidden (raw) routing number when focused
    setShownRoutingNumber(hiddenRoutingNumber);
  };

  const hideWithXsRoutingNumber = () => {
    if (shownRoutingNumber !== "") {
      // Mask the input value by replacing with 'X's
      const maskedValue = "X".repeat(shownRoutingNumber.length);
      setHiddenRoutingNumber(shownRoutingNumber); // Store the raw card number in hidden state
      setShownRoutingNumber(maskedValue); // Show the masked value in the input field
    }
  };
  /*  Reneter routing number mask */
  const [shownReEnterRoutingNumber, setShownReEnterRoutingNumber] =
    useState(""); // The value shown in the input field
  const [hiddenReEnterRoutingNumber, setHiddenReEnterRoutingNumber] =
    useState(""); // The raw reenter routing number
  const showWithoutXsReEnterRoutingNumber = () => {
    // Set the input field value to the hidden (raw) reenter routing number when focused
    setShownReEnterRoutingNumber(hiddenReEnterRoutingNumber);
  };

  const hideWithXsReEnterRoutingNumber = () => {
    if (shownReEnterRoutingNumber !== "") {
      // Mask the input value by replacing with 'X's
      const maskedValue = "X".repeat(shownReEnterRoutingNumber.length);
      setHiddenReEnterRoutingNumber(shownReEnterRoutingNumber); // Store the raw card number in hidden state
      setShownReEnterRoutingNumber(maskedValue); // Show the masked value in the input field
    }
  };
  /* Mask Routing number */
  /* Mask Account number */
  const [shownAccountNumber, setShownAccountNumber] = useState(""); // The value shown in the input field
  const [hiddenAccountNumber, setHiddenAccountNumber] = useState(""); // The raw card number

  const showWithoutXsAccountNumber = () => {
    // Set the input field value to the hidden (raw) card number when focused
    setShownAccountNumber(hiddenAccountNumber);
  };

  const hideWithXsAccountNumber = () => {
    if (shownAccountNumber !== "") {
      // Mask the input value by replacing with 'X's
      const maskedValue = "X".repeat(shownAccountNumber.length);
      setHiddenAccountNumber(shownAccountNumber); // Store the raw card number in hidden state
      setShownAccountNumber(maskedValue); // Show the masked value in the input field
    }
  };
  /*  Reneter account number mask */
  const [shownReEnterAccountNumber, setShownReEnterAccountNumber] =
    useState(""); // The value shown in the input field
  const [hiddenReEnterAccountNumber, setHiddenReEnterAccountNumber] =
    useState(""); // The raw card number
  const showWithoutXsReEnterAccountNumber = () => {
    // Set the input field value to the hidden (raw) card number when focused
    setShownReEnterAccountNumber(hiddenReEnterAccountNumber);
  };

  const hideWithXsReEnterAccountNumber = () => {
    if (shownReEnterAccountNumber !== "") {
      // Mask the input value by replacing with 'X's
      const maskedValue = "X".repeat(shownReEnterAccountNumber.length);
      setHiddenReEnterAccountNumber(shownReEnterAccountNumber); // Store the raw card number in hidden state
      setShownReEnterAccountNumber(maskedValue); // Show the masked value in the input field
    }
  };
  /* Mask Account number */
  const handleAccountDetails = (e) => {
    let { name, value } = e.target;

    //Sanitize input to prevent XSS attacks
    value = dompurifyInput(value);

    if (name === "phoneNumber") {
      value = formatPhone(value);
    }

    /* Mask values */
    if (name === "routingNumber") {
      setShownRoutingNumber(value);
    }
    if (name === "reRoutingNumber") {
      setShownReEnterRoutingNumber(value);
    }
    if (name === "accountNumber") {
      setShownAccountNumber(value);
    }
    if (name === "reAccountNumber") {
      setShownReEnterAccountNumber(value);
    }
    /* Mask values */
    setForm({ ...form, [name]: value });
    setAccountErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setForm((prevValues) => ({
      ...prevValues,
      [name]: checked,
    }));
    setAccountErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const formatAmount = (value) => {
    if (value !== null && value !== undefined) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
    return "0.00";
  };
  useEffect(() => {
    if (nachaContent && showEftTab) {
      const accountLast4Digits = form?.accountNumber
        ? form.accountNumber.toString().slice(-4)
        : "@LAST_FOUR_DIGIT_OF_BANK_ACCOUNT";
      const paymentAmount = showTotalAmt
        ? totalAmountDue
        : payOtherAmount
        ? payOtherAmount
        : "@PAYMENT_AMOUNT";
      const updatedContent = nachaContent
        .replace(/@CURRENT_DATE/g, currentDate)
        .replace(/@PAYMENT_AMOUNT/g, "$" + formatAmount(paymentAmount))
        .replace(/@LAST_FOUR_DIGIT_OF_BANK_ACCOUNT/g, accountLast4Digits)
        .replace(/@PAYMENT_DATE/g, currentDate)
        .replace(/@CARRIER_NAME/g, nachaCarrierName)
        .replace(/@BILL_FREQUENCY/g, nachaBillingFreq)
        .replace(/@SCHEDULED/g, currentDate);
      setUpdatedNachaContent(updatedContent);
      if (
        accountLast4Digits !== "@LAST_FOUR_DIGIT_OF_BANK_ACCOUNT" &&
        paymentAmount !== "@PAYMENT_AMOUNT"
      ) {
        const footerContent = (
          <div>
            <div className="px-3 mt-4">
              <h4 className="fw-semibold">{nachaMainHeading}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    dompurifyHtml(updatedNachaContent) ||
                    dompurifyHtml(nachaContent),
                }}
              />

              <div>
                <div className="col-12 d-flex" tabIndex="0">
                  <div className="col-xl-8 col-8 mt-2">
                    <input
                      type="checkbox"
                      id="agreeterms"
                      name="termsConditions"
                      required
                      defaultChecked={form.termsConditions}
                      disabled
                    />
                    <label
                      htmlFor="agreeterms"
                      className="form-label fw-semibold grey-heading"
                    >
                      {nachaTermsConditions}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-dialogs text-center">
              <div id="liveAlertPlaceholder"></div>
            </div>
            <div className="col-12 d-flex" tabIndex="0">
              <div className="mt-2 checkbox-sml">
                <input
                  type="checkbox"
                  id="eSign"
                  name="eSign"
                  required
                  defaultChecked={form.eSign}
                  disabled
                />
                <label htmlFor="eSign">
                  <p>
                    {nachaESign}
                    <span className="text-danger">*</span>
                  </p>
                </label>
              </div>
            </div>
            <div className="px-3 mt-4">
              <p>{nachaContentSubHeading}</p>
            </div>
          </div>
        );

        // Convert the JSX content to HTML string using ReactDOMServer.renderToString
        const footerContentHtml = ReactDOMServer.renderToString(footerContent);
        // setNachaAuthMessage(footerContentHtml);
        sessionStorage.setItem("nacha_" + urlCarrier, footerContentHtml);
      }
    }
  }, [
    nachaContent,
    currentDate,
    setNachaContent,
    updatedNachaContent,
    form.accountNumber,
    showTotalAmt,
    totalAmountDue,
    payOtherAmount,
    nachaCarrierName,
    nachaBillingFreq,
    urlCarrier,
    showEftTab,
    form,
    nachaMainHeading,
    nachaESign,
    nachaContentSubHeading,
    nachaTermsConditions,
  ]);

  /* useEffect(() => {
    const footerContent = (
      <footer className="pb-4 mt-4">
        <div className="px-3 mt-4">
          <h4 className="fw-semibold">{nachaMainHeading}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: updatedNachaContent || nachaContent,
            }}
          />

          <div>
            <div className="col-12 d-flex">
              <div className="col-xl-4 col-4 mt-2">
                <input
                  type="checkbox"
                  id="agreeterms"
                  name="termsConditions"
                  required
                  defaultChecked={form.termsConditions}
                />
                <label
                  htmlFor="agreeterms"
                  className="form-label fw-semibold grey-heading"
                >
                  {nachaTermsConditions} <span className="text-danger">*</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-dialogs text-center">
          <div id="liveAlertPlaceholder"></div>
        </div>
        <div className="col-12 d-flex">
          <div className="mt-2 checkbox-sml">
            <input
              type="checkbox"
              id="eSign"
              name="eSign"
              required
              defaultChecked={form.eSign}
            />
            <label htmlFor="eSign">
              <p> {nachaESign}</p>
            </label>
          </div>
        </div>
        <div className="px-3 mt-4">
          <p>{nachaContentSubHeading}</p>
        </div>
      </footer>
    );

    // Convert the JSX content to HTML string using ReactDOMServer.renderToString
    const footerContentHtml = ReactDOMServer.renderToString(footerContent);
    setNachaAuthMessage(footerContentHtml);
  }, [
    form,
    updatedNachaContent,
    nachaContent,
    nachaMainHeading,
    nachaESign,
    nachaContentSubHeading,
    nachaTermsConditions,
    setNachaAuthMessage,
  ]);*/

  const handleContinueClickEft = (event) => {
    event.preventDefault();
    if (accountFormValidate()) {
      setIsVisibleEFTFormDown(true); // Show the div when the button is clicked
      setShowSubmitBtn(true);
      setIsVisibleEFTBtnContinue(false);
    }
    // Focus the footer to ensure it is read by NVDA
    setTimeout(() => {
      const footerElement = document.getElementById("payment-term-cond");
      if (footerElement) {
        footerElement.focus();
      }
    }, 0);
    return false;
  };
  //Format card phone number
  const formatPhone = (value) => {
    /* let newPhone = "";

    // Remove invalid characters (non-numeric)
    const phoneNum = value.replace(/[^0-9]/g, "");

    // Format the phone number
    for (let i = 0; i < phoneNum.length; i++) {
      if (i === 3 || i === 6) {
        newPhone += "-";
      }
      newPhone += phoneNum[i];
    }

    return newPhone;*/
    // Remove all non-digit characters (for validation)
    const digits = value.replace(/\D/g, "");

    // Format the phone number as (XXX) XXX-XXXX
    let formattedValue = "";
    if (digits.length > 0) {
      formattedValue = `(${digits.slice(0, 3)}`;
    }
    if (digits.length > 3) {
      formattedValue += `) ${digits.slice(3, 6)}`;
    }
    if (digits.length > 6) {
      formattedValue += `-${digits.slice(6, 10)}`;
    }
    return formattedValue;
  };
  return (
    <>
      {isEnableEft && (
        <>
          <div
            /* EFT TAB*/
            className={`tab-pane fade ${showEftTab ? "show active" : ""}`}
            id="eft"
            role="tabpanel"
            aria-labelledby="eft-tab"
            tabIndex={0}
          >
            <div className="help-text-eft" id="help-text-eft" tabIndex="0">
              <p>{cms.label_eft_help_text_para1}</p>
              <ul className="square-items mini">
                <li>{cms.label_eft_help_text_line1}</li>
                <li>{cms.label_eft_help_text_line2}</li>
                <li>{cms.label_eft_help_text_line3}</li>
                <li>{cms.label_eft_help_text_line4}</li>
              </ul>
            </div>
            <div className="mb-2">
              <div className="d-xl-flex d-md-flex d-sm-block">
                <div className="col-xl-6 col-md-6 col px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="RoutingNumber"
                      placeholder={cms.label_pmt_routing_no}
                      required={showEftTab}
                      name="routingNumber"
                      maxLength="9"
                      onChange={handleAccountDetails}
                      value={shownRoutingNumber}
                      onFocus={showWithoutXsRoutingNumber} // When focused, show the raw card number
                      onBlur={hideWithXsRoutingNumber} // When blurred, mask with 'X's
                    />
                    <span className="input-group-append">
                      <i
                        className={`me-2 fe fe-info fe-11 position-absolute grey-icons mt-1 align-middle hover-text end-0 ${
                          urlCarrier === "bcbsaz" ? "navy-icon" : ""
                        }`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                      >
                        {/* Tooltip*/}
                        <div className="tooltip-text" id="top">
                          <div className="indicator" />
                          <div className="tool-list">
                            <img
                              src={`${process.env.PUBLIC_URL}/images/illustrations/ABA-Routing.svg`}
                              className="mw-90"
                              alt="9-Digit ABA/Routing Number"
                            />
                          </div>
                        </div>
                        {/* Tooltip End*/}
                      </i>
                    </span>
                    <label htmlFor="" className="form-label">
                      {cms.label_pmt_routing_no}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.routingNumber && (
                    <div id="payments-validation-error">
                      {accountErrors.routingNumber}
                    </div>
                  )}
                </div>
                <div className="col-xl-6 col-md-6 px-2 ">
                  <div className="form-floating mb-2 border-bottom position-relative ">
                    <input
                      type="text"
                      className="form-control"
                      id="reRoutingNumber"
                      name="reRoutingNumber"
                      placeholder={cms.label_pmt_routing_no_renter}
                      required={showEftTab}
                      maxLength="9"
                      onChange={handleAccountDetails}
                      value={shownReEnterRoutingNumber}
                      onFocus={showWithoutXsReEnterRoutingNumber} // When focused, show the raw card number
                      onBlur={hideWithXsReEnterRoutingNumber} // When blurred, mask with 'X's
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/card-number-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/card-number.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Re-enter 9-Digit ABA/Routing Number"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="" className="form-label">
                      {cms.label_pmt_routing_no_renter}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.reRoutingNumber && (
                    <div id="payments-validation-error">
                      {accountErrors.reRoutingNumber}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-xl-flex d-md-flex d-sm-block">
                <div className="col-xl-6 col-md-6 col px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="Accountnumber"
                      placeholder=""
                      required={showEftTab}
                      name="accountNumber"
                      value={shownAccountNumber}
                      onFocus={showWithoutXsAccountNumber} // When focused, show the raw card number
                      onBlur={hideWithXsAccountNumber} // When blurred, mask with 'X's
                      onChange={handleAccountDetails}
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/Bank-grey-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/Bank-grey.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Account Number"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="Accountnumber" className="form-label">
                      {cms.label_pmt_accnt_no}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.accountNumber && (
                    <div id="payments-validation-error">
                      {accountErrors.accountNumber}
                    </div>
                  )}
                </div>
                <div className="col-xl-6 col-md-6 col px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="ReAccountnumber"
                      placeholder=""
                      required={showEftTab}
                      value={shownReEnterAccountNumber}
                      onFocus={showWithoutXsReEnterAccountNumber} // When focused, show the raw card number
                      onBlur={hideWithXsReEnterAccountNumber} // When blurred, mask with 'X's
                      name="reAccountNumber"
                      onChange={handleAccountDetails}
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/Bank-grey-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/Bank-grey.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Re-enter Account Number"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="ReAccountnumber" className="form-label">
                      {cms.label_pmt_acct_no_reenter}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.reAccountNumber && (
                    <div id="payments-validation-error">
                      {accountErrors.reAccountNumber}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-xl-flex d-md-flex d-sm-block">
                <div className="col-xl-6 col-md-6 col px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <select
                      className="floating-select"
                      value={form.accountType}
                      name="accountType"
                      onChange={handleAccountDetails}
                      required={showEftTab}
                      aria-label={cms.label_pmt_account_type}
                    >
                      <option></option>
                      {allowedEftTypes &&
                        allowedEftTypes.map((eft, index) => (
                          <option
                            key={index}
                            value={`${eft.level}-${eft.type}`}
                          >
                            {`${eft.level}-${eft.type}`}
                          </option>
                        ))}
                    </select>
                    <label htmlFor="" className="form-label">
                      {cms.label_pmt_account_type}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.accountType && (
                    <div id="payments-validation-error">
                      {accountErrors.accountType}
                    </div>
                  )}
                </div>
                <div className="col-xl-6 col-md-6 col px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="BankAccountName"
                      placeholder=""
                      required={showEftTab}
                      value={form.bankAccountHolderName}
                      name="bankAccountHolderName"
                      onChange={handleAccountDetails}
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/Bank-grey-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/Bank-grey.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Bank Account Holder Name"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="BankAccountName" className="form-label">
                      {cms.label_pmt_accnt_holder_name}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.bankAccountHolderName && (
                    <div id="payments-validation-error">
                      {accountErrors.bankAccountHolderName}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-xl-flex d-md-flex d-sm-block">
                <div className="col-xl-6 col-md-6 col px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="BillingAddress1"
                      placeholder={cms.label_pmt_billing_addr1}
                      required={showEftTab}
                      name="billingAddress1"
                      value={form.billingAddress1}
                      onChange={handleAccountDetails}
                      maxLength="55"
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Billing Address 1 "
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="" className="form-label">
                      {cms.label_pmt_billing_addr1}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.billingAddress1 && (
                    <div id="payments-validation-error">
                      {accountErrors.billingAddress1}
                    </div>
                  )}
                </div>
                <div className="col-xl-6 col-md-6 px-2">
                  <div className="form-floating mb-2 border-bottom position-relative no-feedback">
                    <input
                      type="text"
                      className="form-control"
                      id="BankBilling2"
                      name="billingAddress2"
                      placeholder={cms.label_pmt_billing_addr2}
                      value={form.billingAddress2}
                      onChange={handleAccountDetails}
                      maxLength="55"
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Billing Address 2"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="" className="form-label">
                      {cms.label_pmt_billing_addr2}
                    </label>
                  </div>
                  {accountErrors.billingAddress2 && (
                    <div id="payments-validation-error">
                      {accountErrors.billingAddress2}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-xl-flex d-md-flex d-sm-block ">
                <div className="col-xl-6 col-md-6 px-2">
                  <div className="form-floating mb-2 border-bottom position-relative no-feedback">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      value={form.email}
                      placeholder={cms.label_pmt_email}
                      onChange={handleAccountDetails}
                      maxLength="80"
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/mail-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/mail.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Email"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="Email" className="form-label">
                      {cms.label_pmt_email}
                    </label>
                  </div>
                  {accountErrors.email && (
                    <p id="payments-validation-error">
                      {accountErrors.email}
                    </p>
                  )}
                </div>
                <div className="col-xl-6 col-md-6 px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      name="phoneNumber"
                      value={form.phoneNumber}
                      placeholder={cms.label_pmt_phno}
                      required={showEftTab}
                      onChange={handleAccountDetails}
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile.svg`
                        }
                        className="me-2 position-absolute"
                        width={17}
                        height={17}
                        alt="Mobile"
                      />
                    </span>
                    <label htmlFor="eftPhone" className="form-label">
                      {cms.label_pmt_phno}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.phoneNumber && (
                    <div id="payments-validation-error">
                      {accountErrors.phoneNumber}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-xl-flex d-md-flex d-sm-block">
                <div className="col-xl-6 col-md-6 px-2">
                  <div className="col-12 d-flex">
                    <div className="col-xl-6 col-md-6 px-2">
                      <div className="form-floating mb-2 border-bottom position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="BankCity"
                          name="city"
                          value={form.city}
                          placeholder="City"
                          required={showEftTab}
                          onChange={handleAccountDetails}
                        />
                        <span className="input-group-append">
                          <img
                            src={
                              urlCarrier === "bcbsaz"
                                ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin-bcbsaz.svg`
                                : `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin.svg`
                            }
                            className="me-2 position-absolute"
                            alt="City"
                            width={17}
                            height={17}
                          />
                        </span>
                        <label htmlFor="BankCity" className="form-label">
                          {cms.label_pmt_city}{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      {accountErrors.city && (
                        <div id="payments-validation-error">
                          {accountErrors.city}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-6 col-md-6 px-2">
                      <div className="form-floating mb-2 border-bottom position-relative">
                        <select
                          className="floating-select"
                          name="state"
                          value={form.state}
                          placeholder="State"
                          onChange={handleAccountDetails}
                          aria-label={cms.label_pmt_state}
                        >
                          <option value=""></option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="DC">District Of Columbia</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                        {/*<span className="input-group-append">
                          <img
                            src={`${process.env.PUBLIC_URL}/images/icons/Payment/faBuilding.svg`}
                            className="me-2 position-absolute"
                            alt="State"
                            width={17}
                            height={17}
                          />
                        </span>*/}
                        <label htmlFor="BankState" className="form-label">
                          {cms.label_pmt_state}{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      {accountErrors.state && (
                        <div id="payments-validation-error">
                          {accountErrors.state}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-md-6 px-2">
                  <div className="form-floating mb-2 border-bottom position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="BankZip"
                      name="zip"
                      placeholder="Zip"
                      required={showEftTab}
                      value={form.zip}
                      onChange={handleAccountDetails}
                    />
                    <span className="input-group-append">
                      <img
                        src={
                          urlCarrier === "bcbsaz"
                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-bcbsaz.svg`
                            : `${process.env.PUBLIC_URL}/images/icons/Payment/map.svg`
                        }
                        className="me-2 position-absolute"
                        alt="Zip"
                        width={17}
                        height={17}
                      />
                    </span>
                    <label htmlFor="BankZip" className="form-label">
                      {cms.label_pmt_zip} <span className="text-danger">*</span>
                    </label>
                  </div>
                  {accountErrors.zip && (
                    <div id="payments-validation-error">
                      {accountErrors.zip}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {isVisibleEFTBtnContinue && showEftTab && (
            <button
              type="button"
              className=" mt-2  btn btn-primary btn-lg button"
              onClick={handleContinueClickEft}
            >
              {cms.label_continue}
            </button>
          )}
          {isVisibleEFTFormDown && showEftTab && (
            <footer className="pb-4 mt-4" tabIndex="0" id="payment-term-cond" aria-live="assertive">
              <div className="px-3 mt-4">
                <h4 className="fw-semibold nacha-heading">{nachaMainHeading}</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      dompurifyHtml(updatedNachaContent) ||
                      dompurifyHtml(nachaContent),
                  }}
                />
                {nachaContent && (
                  <div>
                    <div className="col-12 mt-2" tabIndex="0">
                      <div className="d-flex align-items-start flex-nowrap gap-2">
                        <input
                          type="checkbox"
                          id="agreeterms"
                          name="termsConditions"
                          required
                          checked={form.termsConditions}
                          onChange={handleCheckboxChange}
                          style={{ marginTop: "3px", flexShrink: 0 }}
                        />
                        <label
                          htmlFor="agreeterms"
                          className="form-label fw-semibold grey-heading mb-0"
                        >
                          {nachaTermsConditions}{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      {accountErrors.termsConditions && (
                        <p id="payments-validation-error" className="mt-1 ms-0">
                          {accountErrors.termsConditions}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-dialogs text-center">
                <div id="liveAlertPlaceholder"></div>
              </div>
              {nachaContent && (
                <div className="col-12 d-flex" tabIndex="0">
                  <div className="mt-2 checkbox-sml">
                    <input
                      type="checkbox"
                      id="eSign"
                      name="eSign"
                      required
                      checked={form.eSign}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="eSign">
                      <p>
                        {nachaESign} <span className="text-danger">*</span>
                      </p>
                    </label>
                    {accountErrors.eSign && (
                      <p id="payments-validation-error">
                        {accountErrors.eSign}
                      </p>
                    )}
                  </div>
                </div>
              )}
              <div className="px-3 mt-4">
                <p>{nachaContentSubHeading}</p>
              </div>
            </footer>
          )}
        </>
      )}
    </>
  );
};
export default EFTForm;
